export enum BanksNameEnum {
	"ASAAS" = "ASAAS"
}
